<ng-container *transloco="let t">
  <div class="p-2">
    <div class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()">
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-scroll">
        <div [infiniteScrollDistance]="4" class="table table-last-row-no-border" infinite-scroll>
          <validator-result-message [validatorResult]="validatorResult"></validator-result-message>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      @if (showConfirmButton) {
        <button type="button" class="btn btn-primary" (click)="onConfirmClick()">{{
            confirmButtonTitle ??
            t('app.common.confirm')
          }}
        </button>
      }

      <button type="button" class="btn btn-secondary" data-dismiss="modal"
              (click)="onDismissClick()">{{ dismissButtonTitle ?? t('app.common.cancel') }}
      </button>
    </div>
  </div>
</ng-container>



